
<div class="flex">
  <div class="flex-item">

    @if (dashboardService.loadingSourceMarket || showLoader) {
      <div class="loading-div">
        @if (dashboardService.loadingSourceMarket) {
          <mat-spinner diameter="80" class='full-center-spinner'></mat-spinner>
        }
      </div>
    }

    <div class="chart-container square">
      @if (chartData) {
        <canvas baseChart
          [data]="chartData"
          [type]="pieChartType"
          [options]="pieChartOptions"
          [legend]="pieChartLegend">
        </canvas>
      }
    </div>
  </div>
</div>

